<template>
  <div :style="{height:swiperHeight && swiperHeight + 'px'}" :class="[siteConfigColor == 'black' ? 'site_config_color': '','plugin-wrapper', 'base-swiper', 'swiper' + _uid]" v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <swiper class="swiper-x-container" :ref="'iSwiper' + _uid" :options="swiperOpts" @slideChange="transitionEnd">
      <swiper-slide class="swiper-x-item" v-for="(item, index) in config.nodes" :key="index">
        <template v-if="item.tag == 'image'">
          <img :src="item.src.pc" class="show-for-md swiper-item__image image__fit" @click="actionHandler(item.action)" alt="Sisley Paris" />
          <img :src="item.src.h5" class="hide-for-md swiper-item__image image__fit" @click="actionHandler(item.action)" alt="Sisley Paris" />
          <template v-if="item.h5_hots && !winW">
            <HotItemScale :hotsitem="item.h5_hots" type="h5" ></HotItemScale>
          </template>
          <template v-if="item.pc_hots && winW">
            <HotItemScale :imageWidth="item.pc_width || 1920" :imageHeight="item.pc_height || 1288" :hotsitem="item.pc_hots" type="pc"></HotItemScale>
          </template>
        </template>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div :class="['swiper-button-prev', siteConfigColor == 'black' ? 'swiper-button-black': 'swiper-button-white']" slot="button-prev"></div>
      <div :class="['swiper-button-next', siteConfigColor == 'black' ? 'swiper-button-black': 'swiper-button-white']" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import actionMixins from "@/utils/action.mixins";
import HotItemScale from "@/components/HotItemScale.vue";

export default {
  name: 'Swiper',
  mixins: [actionMixins],
  components: { swiper, swiperSlide, HotItemScale },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      iSwiper: {},
      swiperOpts: {
        loop: true,
        // loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          // dynamicBullets: true,
          bulletClass: "swiper-bullet",
          bulletActiveClass: "swiper-bullet__active",
          clickable: true
        },
        navigation: {
          prevEl: `.swiper${this._uid} .swiper-button-prev`,
          nextEl: `.swiper${this._uid} .swiper-button-next`
        },
        on: {
          slideChangeTransitionEnd () {
            this.slideToLoop(this.realIndex, 0, false);
          }
        }
      },
      swiperHeight: null,
      siteConfigColor: 'black'
    }
  },
  mounted() {
    this.iSwiper = this.$refs?.[`iSwiper` + this._uid]?.swiper;
  },
  created() {
    if(window.innerWidth < 1024){
      this.swiperHeight = window.innerWidth / 750 * 1070
    }
    this.siteConfigColor = this.config?.nodes[0].theme
    this.$store.commit("siteTheme", this.siteConfigColor);
  },
  computed: {
    winW() { return window.innerWidth > 1023; },
  },
  methods: {
    transitionEnd(swiper) {
      this.siteConfigColor = this.config.nodes[this.iSwiper.realIndex].theme
      this.$store.commit("siteTheme", this.siteConfigColor);
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-swiper {
    box-sizing: border-box; width: 100%; height: 1070px;
    .swiper-x-container { width: 100%; height: 100%; }
    .swiper-item__image { width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; margin: 0 auto; cursor: pointer; }
    & /deep/ .swiper-bullet {
      display: inline-block; height: 16px; width: 16px; margin: 0 4px; opacity: 1; cursor: pointer;
      background: 0 0; border-radius: 100%; transform: translate3d(0,0,0) scaleX(1);
      &::before{
        content: '';
        display: block; height: 100%; width: 100%!important; position: absolute; top: 50%; left: 50%;
        cursor: pointer;
        -webkit-transform: translate3d(-50%,-50%,0) scale(0);
        -moz-transform: translate3d(-50%,-50%,0) scale(0);
        transform: translate3d(-50%,-50%,0) scale(0);
        border: 1px solid #fff;
        -webkit-transition: -webkit-transform .5s cubic-bezier(.175,.885,.32,1.275);
        -o-transition: -o-transform .5s cubic-bezier(.175,.885,.32,1.275);
        -moz-transition: transform .5s cubic-bezier(.175,.885,.32,1.275),-moz-transform .5s cubic-bezier(.175,.885,.32,1.275);
        transition: transform .5s cubic-bezier(.175,.885,.32,1.275);
        transition: transform .5s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .5s cubic-bezier(.175,.885,.32,1.275),-moz-transform .5s cubic-bezier(.175,.885,.32,1.275),-o-transform .5s cubic-bezier(.175,.885,.32,1.275);
        border-radius: 50%;
        background-color: transparent
      }
      &::after{
        content: '';
        display: block; width: 5px; height: 5px; position: absolute; top: 50%; left: 50%;
        background: #fff;
        -webkit-transition: opacity .5s, -webkit-transform .5s cubic-bezier(.175,.885,.32,1.275);
        -o-transition: opacity .5s, -o-transform .5s cubic-bezier(.175,.885,.32,1.275);
        -moz-transition: transform .5s cubic-bezier(.175,.885,.32,1.275),opacity .5s,-moz-transform .5s cubic-bezier(.175,.885,.32,1.275);
        transition: transform .5s cubic-bezier(.175,.885,.32,1.275),opacity .5s;
        transition: transform .5s cubic-bezier(.175,.885,.32,1.275),opacity .5s,-webkit-transform .5s cubic-bezier(.175,.885,.32,1.275),-moz-transform .5s cubic-bezier(.175,.885,.32,1.275),-o-transform .5s cubic-bezier(.175,.885,.32,1.275);
        -webkit-transform: translate3d(-50%,-50%,0);
        -moz-transform: translate3d(-50%,-50%,0);
        transform: translate3d(-50%,-50%,0);
        border-radius: 50%;
        opacity: 1
      }
      &.swiper-bullet__active {
        &:after {
          -webkit-transform: translate3d(-50%,-50%,0) scale(0);
          -moz-transform: translate3d(-50%,-50%,0) scale(0);
          transform: translate3d(-50%,-50%,0) scale(0);
          opacity: 0;
        }
      }
      &.swiper-bullet__active:before, &:hover:before {
        -webkit-transform: translate3d(-50%,-50%,0) scale(.7);
        -moz-transform: translate3d(-50%,-50%,0) scale(.7);
        transform: translate3d(-50%,-50%,0) scale(.7);
      }
    }
  }
  .site_config_color{
    & /deep/ .swiper-bullet {
      display: inline-block; height: 16px; width: 16px; margin: 0 4px; opacity: 1; cursor: pointer;
      background: 0 0; border-radius: 100%; transform: translate3d(0,0,0) scaleX(1);
      &::before{
        content: '';
        border: 1px solid #000;
      }
      &::after{
        content: '';
        background: #000;
      }
    }
  }

  @media screen and (min-width: 64em) {
    .base-swiper { height: 100vh; }
  }

  @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .base-swiper .image__fit {
      width: 100%; height: auto;
      position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    }
  }
</style>